import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=33e7fb79&"
import script from "./connections.ts?vue&type=script&lang=ts&"
export * from "./connections.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports